'use strict';

import { cn } from '@src/utils/ui';

const React = require('react');
const PropTypes = require('prop-types');

export const ServiceBadge = ({ className, children }) => {
    return (
        // tw-p-[10px] from figma doesn't work due to conflicting css on render, don't overthink for now
        <div
            className={cn(
                'tw-h-[30px] tw-rounded-[8px] tw-p-[9px] tw-text-[12px] tw-leading-[1] tw-tracking-[0]',
                className
            )}
        >
            {children}
        </div>
    );
};

ServiceBadge.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired
};
